import { render, staticRenderFns } from "./BaseManagePermissionCreateView.vue?vue&type=template&id=50fb0d54&"
import script from "./BaseManagePermissionCreateView.vue?vue&type=script&lang=js&"
export * from "./BaseManagePermissionCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports